import { API } from "../APIs/index";
import { TokenValidator } from "./TokenValidator";
import { Tokens } from "../Interfaces/Interfaces";
import qs from "qs";

export default class AuthService {
  tokens: any | Tokens;
  constructor() {
    this.tokens = TokenValidator();
  }

  identity = API.identity + "post/api/account/";
  otp = API.otp + "post/sendOtp/";
  token = API.identity + "post/connect/token";

  async getToken(data: any) {
    try {
      let response = await fetch(this.token, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: qs.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async login(data: any) {
    try {
      let response = await fetch(this.token, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: qs.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async forgotPassword(data: any) {
    try {
      let response = await fetch(this.identity + "forgotPassword", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async resetPassword(data: any) {
    try {
      let response = await fetch(this.identity + "password/reset", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async changePassword(data: any) {
    try {
      let response = await fetch(this.identity + "password/change", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async sendOTP(data: any) {
    try {
      let response = await fetch(this.otp, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async confirmEmail(data: any) {
    try {
      let response = await fetch(this.identity + "confirmEmail", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async resendConfirmationLink(data: any) {
    try {
      let response = await fetch(this.identity + "resendConfirmationLink", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async activateAndDeactivateAdminService(data: any) {
    try {
      let response = await fetch(this.identity + "toggleactive", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
}
